import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared';
import {MembershipCardTypeContainerModel} from '../../../../../../models/aggregates/crm/membership-card-type';
import {Core2Config} from '../../shared';


@Injectable({
  providedIn: 'root'
})
export class MembershipCardTypeBackOfficeService extends BaseApiTemplateService<MembershipCardTypeContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_URL_PREFIX + Core2Config.DOMAIN_PREFIX + Core2Config.CRM_PREFIX + 'membership-card-type-hdrs/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL +  Core2Config.TENANT_URL_PREFIX + Core2Config.DOMAIN_PREFIX + Core2Config.CRM_PREFIX + 'membership-card-type-hdrs/backoffice-ep';
    this.endpoint_path =  Core2Config.TENANT_URL_PREFIX + Core2Config.DOMAIN_PREFIX + Core2Config.CRM_PREFIX + 'membership-card-type-hdrs/backoffice-ep';
    this.httpClient = http;
  }

}


